var map = {
	"./favicons_1688.png": 433,
	"./favicons_amazon.png": 894,
	"./favicons_pinduoduo.png": 895,
	"./favicons_shopee.png": 896,
	"./favicons_taobao.png": 434,
	"./favicons_tmall.png": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 893;